(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
    Initiates Story Feed functionality
 */
var QipStoryFeed = /*#__PURE__*/function () {
  function QipStoryFeed() {
    _classCallCheck(this, QipStoryFeed);
    var _self = this;
    _self.offset = 1000; //how many pixels before end of stories is in view we should lazy load next set of stories

    /*
        Initialize functions (ie. isinviewport function)
     */
    _self.initializeFunctions();

    /*
       Set event listeners
    */
    _self.setEventListeners();

    //set ajax url
    if (typeof ajaxurl === "undefined") {
      _self.ajaxurl = document.body.getAttribute('ajaxurl');
    } else {
      _self.ajaxurl = qip_ajax_url;
    }
  }

  /*
      Set event listeners for story feed
   */
  return _createClass(QipStoryFeed, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;

      /*
          Show comments when user clicks on comments button
       */
      _self.addActionShowComments();

      /*
          Expand a minimized story when clicking on it
       */
      _self.addActionExpandMinimizedStory();

      /*
          Initialized infinite scroll for stories
       */
      _self.initializeStoryFeedInfiniteScroll();
    }

    /*
        Initialized infinite scroll for stories
     */
  }, {
    key: "initializeStoryFeedInfiniteScroll",
    value: function initializeStoryFeedInfiniteScroll() {
      console.log('initializeStoryFeedInfiniteScroll()');
      var _self = this;

      /*
          Every 300px scrolled check if the 'end_of_stories' div (+ selected offset) is in viewport
       */

      var starting_position = jQuery(window).scrollTop();
      var current_position = 0;
      jQuery(window).on('resize scroll', function () {
        /*
            If we havent scrolled 300px yet then dont run checks yet
         */
        current_position = jQuery(window).scrollTop();
        if (Math.abs(starting_position - current_position) <= 300) return;

        /*
            Check that we are not already loading stories thorugh html (happens if user scrolls down too quickly)
            and if so dont go through process again
         */
        if (window.in_process_of_loading_story_through_ajax === true) {
          // console.log('Error - cant load more stories through ajax call - already in the process of doing so - scrolling down too quickly!');
          return;
        }
        starting_position = jQuery(window).scrollTop(); //reset starting position after running taggy functions

        /*
            If we are out of stories completely stop checking the resize scroll
         */
        var end_of_stories_div = jQuery('#end_of_stories');
        var out_of_stories = end_of_stories_div.attr('out-of-stories');
        if (out_of_stories === "true") return false;
        console.log('checking!!!');

        /*
            Check if end of stories div is in viewport and if so load next batch of stories
         */

        //if there is no div found just return
        console.log('LENGTH of end:', end_of_stories_div.length);
        if (end_of_stories_div.length === 0) return;

        //check if div is is in viewport and load stories
        var inViewPort = jQuery('#end_of_stories').isInViewport(_self.offset);
        if (inViewPort) {
          /*
              If user scrolls too fast and user keeps scrolling while content is still being
              pulled from database it will cause a bunch of errors (ie. it will load the same stories
              multiple times) so we need to set a variable to keep track of when ajax is pulling
              data so it doesnt try to do so again
           */
          window.in_process_of_loading_story_through_ajax = true;
          console.log('END OF STORIES IS IN VIEWPORT!!');
          var excluded_post_ids = end_of_stories_div.attr('story-ids-displayed');
          var feed_version_test = end_of_stories_div.attr('feed-version-test');
          console.log('feed_version_test 111:', feed_version_test);
          //run ajax request to load more stories
          _self.ajaxLoadMoreStories(excluded_post_ids, feed_version_test, function () {
            //let the system know that we are doing loading html thorugh ahax
            window.in_process_of_loading_story_through_ajax = false;
          });
        }
      });
    }

    /*
        Ajax request to load additional stories
          excluded_post_ids: (string), comma delimited string with posts that have already been shown
        feed_version_test: (string), for a/b test will decide which version of the feed to load, its a number as a string. ie ."1" loads first version
        callback_function: (function), function to run once we are done pulling additional stories from database
     */
  }, {
    key: "ajaxLoadMoreStories",
    value: function ajaxLoadMoreStories(excluded_post_ids) {
      var feed_version_test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "1";
      var callback_function = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var _self = this;
      var params = new FormData();
      params.append('action', 'qip_get_more_stories_for_story_feed');
      params.append('qip_general_nonce', qip_general_nonce);
      params.append('excluded_post_ids', excluded_post_ids);

      /*
          The version of feed to load for A/B testing
       */
      params.append('feed_version_test', feed_version_test);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
          /*
              Run callback function for when ajax pull is complete
           */
          callback_function();
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: could not get additional stories');
          }
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          var content_html = response.content_html;
          jQuery('#end_of_stories').replaceWith(content_html);

          /*
              Add Event listerner - Show comments when user clicks on comments button
           */
          _self.addActionShowComments();

          /*
              Initialize upvotes buttons
           */

          console.log('initializing upvotes bars!');
          window.initializeAllUpvotesBars();

          /*
              Add Event listerner -  Expand a minimized story when clicking on it
           */
          _self.addActionExpandMinimizedStory();
        }

        /*
            Run callback function for when ajax pull is complete
         */
        callback_function();
      });
    }

    /*
        Add action to show comments when the comments icon is clicked on the story feed
     */
  }, {
    key: "addActionShowComments",
    value: function addActionShowComments() {
      var _self = this;
      var show_comments_buttons = document.querySelectorAll('.story-feed-show-comments-button');
      show_comments_buttons.forEach(function (show_comments_button) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */

        var story_id = show_comments_button.getAttribute('story-id');
        var num_comments = show_comments_button.getElementsByClassName("num-comments")[0].innerHTML;

        /*
            If story has no comments then exit function as no need to initialize more comments button
         */
        if (num_comments === '0') return;

        //add attribute 'init' to button so we dont mistakenly initialize it twice
        if (show_comments_button.getAttribute('init')) return;else {
          show_comments_button.setAttribute('init', 'true');
        }

        //add event listener to button
        show_comments_button.addEventListener('click', function () {
          /*
              We are running a check to make sure user hasnt clicked the comments button
              too quickly and caused it to open/close too fast before system can react
           */
          if (window.feed_comments_clicked_and_still_loading === true) {
            console.log('Error: You clicked comments button too quickly!');
            return;
          }
          window.feed_comments_clicked_and_still_loading = true;

          /*
              Figure out if we have already shown comments, and if so hide comments
              instead
           */
          var comments_already_shown = show_comments_button.classList.contains('selected');

          //comments are already shown
          if (comments_already_shown) {
            //delete comments and remove selected class
            show_comments_button.classList.remove('selected');
            var comments_for_story = document.getElementById("comments_box_for_story_".concat(story_id));
            if (comments_for_story) comments_for_story.remove();
            window.feed_comments_clicked_and_still_loading = false;
          }

          //if comments arent showing yet
          else {
            /* Add class to comments button to show it as expanded */
            show_comments_button.classList.add('selected');

            /*
                Get initial comments an input them into page  - set callback function to
                let system know that comments are done loading
            */
            _self.ajaxGetInitialCommentsForStoryInStoryFeed(story_id, 0, [], function () {
              window.feed_comments_clicked_and_still_loading = false;
            });
          }
        });
      });
    }

    /*
        Ajax call to get initial comments for story feed for individual story when user clicks on show comments button
          article_id: (int), the post id of the article we want to load more comments for
        total_comments_loaded: (int), the total number of comments that have already been loaded for a specific article
        callback_function: (function), function to run after comments are initialized
       */
  }, {
    key: "ajaxGetInitialCommentsForStoryInStoryFeed",
    value: function ajaxGetInitialCommentsForStoryInStoryFeed(article_id) {
      var _this = this;
      var total_comments_loaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var comment_ids_to_exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var callback_function = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      var _self = this;
      var params = new FormData();
      params.append('action', 'qip_get_initial_story_feed_comments_for_article');

      //we need to submit both nonces, because logged in and logged out users will get more content
      if (typeof logged_in_nonce !== 'undefined') {
        params.append('logged_in_nonce', logged_in_nonce);
      }

      //if we dont have a logged_in_nonce set, then set it to blank
      params.append('qip_comments_nonce', qip_comments_nonce);
      params.append('article_id', article_id);
      params.append('total_comments_loaded', total_comments_loaded);
      params.append('comments_to_exclude', comment_ids_to_exclude);
      console.log('total_comments_loaded:', total_comments_loaded);
      console.log('comments_to_exclude:', comment_ids_to_exclude);
      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }

        /*
            Run callback function after ajax query is completed
         */
        callback_function();
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: could not get additional comments');
          }
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          // console.log('response:', response.comments_html);

          var qip_bar = document.getElementById("qip-story-feed-upvotes-comment-bar-".concat(article_id));
          console.log('qip bar:', qip_bar);

          /*
              Create the comment div to insert
           */
          var comments_box = document.createElement("div");
          comments_box.id = "comments_box_for_story_".concat(article_id);
          comments_box.style.paddingTop = "20px"; //add padding to the div in order to leave enough space
          comments_box.innerHTML = response.comments_html;

          /*
              Insert the new comments box below the qip upvotes/comments bar
           */
          _this.insertAfter(comments_box, qip_bar);

          /*
              Initialize comments class and request comments from api and set all necessary event listeners
              for comments to work
           */
          var comments_obj = new QipComments();
          var comments = comments_obj.setEventListeners();
        }

        /*
            Run callback function after ajax query is completed
         */
        callback_function();
      });
    }

    /*
        Add action to unide the minimized story and bring in rest of story when user clicks on minimized story in feed
     */
  }, {
    key: "addActionExpandMinimizedStory",
    value: function addActionExpandMinimizedStory() {
      var _self = this;

      /*
          Find story divs that are minimized
       */
      var minimized_story_divs = document.querySelectorAll('.story-feed-excerpt.minimized');
      minimized_story_divs.forEach(function (minimized_story_div) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */

        var story_id = minimized_story_div.getAttribute('story-id');
        // console.log(` minimized_story_div ${story_id}`);

        /*
            If story has no comments then exit function as no need to initialize more comments button
         */
        //add attribute 'init' to button so we dont mistakenly initialize it twice
        if (minimized_story_div.getAttribute('init')) return;else {
          minimized_story_div.setAttribute('init', 'true');
        }

        //add event listener to button
        minimized_story_div.addEventListener('click', function () {
          console.log('minumuized story div was clicked! minimuized story div:', minimized_story_div);
          /*
              Make loading button visible
           */
          var spinner_loading_button = document.getElementById("spinner-loading-".concat(story_id));
          console.log('spinner_loading_button:', spinner_loading_button);
          spinner_loading_button.classList.remove('d-none');
          console.log('spinner now showing!');

          /*
              Pull the full story from ajax request and replace existing story with full story
           */
          _self.ajaxGetFullStoryForStoryFeed(story_id, function () {
            /*
                Callback function to remove the 'minimized' class from div once content has been loaded
             */
            var comments_already_shown = minimized_story_div.classList.remove('minimized');

            /*
                Make loading spinner invisible after loading
             */
            spinner_loading_button.classList.add('d-none');
          });
        });
      });
    }

    /*
        Pull the full story from the database and replace the minimized story with it
          story_id: (int), the story if for the story we want the full text for
        callback_success: (funciton), a callback function to run if we are able to get the full story succesfully
     */
  }, {
    key: "ajaxGetFullStoryForStoryFeed",
    value: function ajaxGetFullStoryForStoryFeed(story_id, callback_success) {
      console.log('in ajaxGetFullStoryForStoryFeed -- story id:', story_id);
      var _self = this;
      var params = new FormData();
      params.append('action', 'qip_get_full_story');
      params.append('qip_general_nonce', qip_general_nonce);
      params.append('story_id', story_id);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: could not get additional comments');
          }
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          // console.log('response:', response.content_html);

          // const story_excerpt = document.getElementById(`qip-story-feed-upvotes-comment-bar-${article_id}`);
          var story_excerpt = document.getElementById("story-feed-excerpt-".concat(story_id));

          /*
              Replace existing excerpt with full story
           */
          story_excerpt.innerHTML = response.content_html;

          /*
              Run callback in order to delete the "fog" after full content has been loaded
           */
          callback_success();
        }
      });
    }

    /*
        Initialize functions such as jQuery isInViewPort function to check if a specifid div is in the viewport
     */
  }, {
    key: "initializeFunctions",
    value: function initializeFunctions() {
      jQuery.fn.isInViewport = function () {
        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var elementTop = jQuery(this).offset().top - offset;
        var elementBottom = elementTop + jQuery(this).outerHeight();
        var viewportTop = jQuery(window).scrollTop();
        var viewportBottom = viewportTop + jQuery(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      };
    }

    /*
        Inserts one element after an existing element in html dom
          newNode: (string), the new html element you want to insert
        referenceNode: (string), the html you want to insert some hing after
     */
  }, {
    key: "insertAfter",
    value: function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
  }]);
}();
/*
    Once dom has been loaded then initialize the qip comments class
 */
document.addEventListener("DOMContentLoaded", function () {
  //initialize class
  var story_feed_obj = new QipStoryFeed();
});

},{}]},{},[1]);
